import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';

import styles from '../../MenuItem.module.scss';
import { UserTypes } from '../../../../domains/user/user-types';

import { ReactComponent as InvoiceIcon } from '../../../../assets/icons/icon_invoice.svg';

const CoachInvoicesButton = ({ handleMenuLinkClick, user }) => {
  if (user?.user_type !== UserTypes.tutor) return;

  return (
    <li className={styles['link-wrapper']} data-testid="invoices-button">
      <NavLink
        to="/invoices"
        onClick={() => handleMenuLinkClick('invoices')}
        activeClassName={styles.isActive}
        className={styles.menuItem}
        data-testid="invoices-link">
        <div className={styles['button-wrapper']}>
          <div className={styles['background']}>
            <InvoiceIcon />
          </div>
          <span>Invoices</span>
        </div>
      </NavLink>
    </li>
  );
};

CoachInvoicesButton.propTypes = {
  handleMenuLinkClick: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired
};

export default CoachInvoicesButton;
